import Wrapper from './components/Wrapper';

const MarcomLayout = {
  Wrapper,
};

export default MarcomLayout;
